import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Server02 = function Server02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M6 8h.01M6 16h.01M6 12h12M6 12c-2.2091 0-4-1.7909-4-4s1.7909-4 4-4h12c2.2091 0 4 1.7909 4 4s-1.7909 4-4 4M6 12c-2.2091 0-4 1.7909-4 4s1.7909 4 4 4h12c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4"
    })
  }));
};
export default Server02;